import qs from 'querystring';
import Cookies from 'js-cookie';
import AuthService from '@/util/auth.service';
import router from '@/router';
import { usuarioEfectivo } from '@/util/accesos-perfil';

const defaultState = {
  JSESSIONID: '',
  user: {},
  lastUser: null
};

const getters = {
  getAccessToken: (state) => state.JSESSIONID,
  // Usuario EFECTIVO: con PERMISOS_POR_PERFIL activo, sus accesos vienen del
  // perfil (módulo `accesos`); sin él, es state.user tal cual. Es de solo
  // lectura: nunca mandarlo de vuelta al servidor (lleva accesosPorPerfil y
  // valores del perfil), para eso está state.user.
  getUser: (state, _getters, rootState) => usuarioEfectivo(state.user, rootState.accesos),
};

const actions = {
  async login({ commit, dispatch }, { username, password, _undefined }) {
    // eslint-disable-next-line
    return new Promise(async (resolve, reject) => {
      AuthService({
        url: '/session',
        method: 'post',
        data: qs.stringify({
          email: username,
          password,
          undefined: _undefined
        }),
      }).then(async (data) => {
        commit('SET_ACCESS_TOKEN', Cookies.get('JSESSIONID'));
        // Sin restos del perfil de una sesión anterior.
        commit('accesos/RESET_ACCESOS', null, { root: true });
        commit('SET_LOGIN', { data });
        await dispatch('accesos/cargar', null, { root: true });
        resolve()
      }).catch(reject);
      // dispatch('fetchProfile');
    })
  },
  logout({ commit }) {
    commit('SET_ACCESS_TOKEN', null);
    // AuthService({
    //   url: '/session',
    //   method: 'get',
    // }).then(() => {
    //   AuthService({
    //     url: '/session',
    //     method: 'delete',
    //   })
    // })
    window.VMA.$emit('SHOW_SNACKBAR', {
      text: 'Logout successfull',
      color: 'success'
    });
    // Cookies.remove('JSESSIONID');
    commit('SET_LOGOUT');
    // router.push('/auth/login');
  },
  // get current login user info
  fetchProfile() {
    /* return AuthService({
      url: '/me',
      method: 'get'
    }).then(({ data }) => {
      commit('SET_LOGIN_PROFILE', data);
    }); */
  },
  updateProfile({ commit }, data) {
    commit('SET_LOGIN', { data, update: true });
  }
};

const mutations = {
  SET_LOGIN(state, { data, update = false }) {
    if (!update && state.lastUser !== data.id) {
      this.dispatch('cameras/clearStore', null, { root: true })
      this.dispatch('alerts/clearStore', null, { root: true })
      this.dispatch('map/clearStore', null, { root: true })
      this.dispatch('map-v2/clearAllPins', null, { root: true })
      this.dispatch('map-v2/clearAllMurphyPins', null, { root: true })
      this.commit('map-v2/SET_MURPHY_RESULT', null, { root: true })
      this.dispatch('map-v2/clearFaceSearchState', null, { root: true })
      // El seguimiento es de quien lo inició: en una estación con turnos
      // rotativos, el operador entrante no debe heredar la unidad que venía
      // siguiendo el saliente.
      this.commit('map-v2/CLEAR_FOLLOWED_UNIT', null, { root: true })
      // Selección del operador saliente y caché IndexedDB de entidades. La
      // garantía real está en CLAIM_OPERATOR_STATE (al montar el mapa) y en la
      // caché por usuario: `lastUser` solo lo escribe el logout explícito.
      this.commit('map-v2/SET_SELECTED_ITEM', null, { root: true })
      this.dispatch('map-v2/clearEntityCache', null, { root: true })
      // Cargar los presets de video wall del usuario que inicia sesión.
      this.commit('map-v2/LOAD_PRESETS_FOR_USER', data.id, { root: true })
    }
    state.user = data;
  },
  SET_LOGOUT(state) {
    // Datos en reposo: la caché de entidades del mapa no sobrevive al logout.
    this.dispatch('map-v2/clearEntityCache', null, { root: true })
    // state.lastUser = state.user ? state.user.id : state.lastUser
    // state.user = {};
    AuthService({
      url: '/session',
      method: 'delete',
    }).then(() => {
      console.log('session deleted');
    }).catch(() => {
      console.log('session not deleted');
    }).finally(() => {
      state.lastUser = state.user ? state.user.id : state.lastUser
      state.user = {};
      this.commit('accesos/RESET_ACCESOS', null, { root: true })
      Cookies.remove('JSESSIONID');
      // Limpiar presets de memoria (simetría con los clearStore del SET_LOGIN).
      this.commit('map-v2/LOAD_PRESETS_FOR_USER', null, { root: true })
      router.push('/auth/login');
    });
  },
  SET_ACCESS_TOKEN(state, JSESSIONID) {
    state.JSESSIONID = JSESSIONID;
  },
  SET_LOGIN_PROFILE(state, payload) {
    state.user = payload;
  }
};

export default {
  namespaced: true,
  defaultState,
  getters,
  actions,
  mutations
};
